import { Cta } from "@/contents/sanityTypes"

export interface CtaProps {
  blok: Cta
}

const SanityCta = ({}: CtaProps) => {
  return <div>cta</div>
}

export default SanityCta
